module.exports = __webpack_public_path__ + "img/cs-4.39226527.jpg";